import { orchestrator } from "satcheljs";

import { clearFilters } from "../../../sh-application/components/schedules/lib";
import { resetTagsPeopleCount } from "../mutators/resetTagsPeopleCount";

export const onClearFilters = orchestrator(clearFilters, () => {
    resetTagsPeopleCount();
});
